import React, { useRef, useState, useEffect } from "react";
import "./HeroHome.css";
import { useDispatch, useSelector } from "react-redux";
import { fetchHomeData } from "../../redux/HomePageSlice";
import { Link } from "react-router-dom";
import HeroHomeIconR from "../../Assets/Svg/Home/HomeHeroIconR.svg";
import HeroHomeIconHover from "../../Assets/Svg/Home/HeroHomeSIcon.svg";

const isSafari = () => {
  const ua = navigator.userAgent.toLowerCase();
  return ua.indexOf("safari") > -1 && ua.indexOf("chrome") < 0;
};

export default function HeroHome() {
  const dispatch = useDispatch();
  const { data } = useSelector((state) => state.homePage);

  const videoParentRef = useRef();
  const videoRef = useRef(null);

  const [isMobile, setIsMobile] = useState(window.innerWidth < 768);
  const [imgSrc, setImgSrc] = useState(HeroHomeIconR);
  const [currentVideo, setCurrentVideo] = useState(0);
  const [videoDuration, setVideoDuration] = useState(0);

  useEffect(() => {
    if (!data || data.length === 0) {
      dispatch(fetchHomeData({ lang: "en" }));
    }
  }, [dispatch, data]);

  const section1 = data?.find((s) => s.section_id === 1);
  const videoUrl = section1?.video;
  const Videos = videoUrl ? [videoUrl, videoUrl] : [];

  useEffect(() => {
    const video = videoRef.current;
    if (!video) return;

    const handleLoadedMetadata = () => {
      if (video.duration) {
        setVideoDuration(video.duration * 1000);
      }
    };

    video.addEventListener("loadedmetadata", handleLoadedMetadata);
    return () => video.removeEventListener("loadedmetadata", handleLoadedMetadata);
  }, [videoUrl]);

  useEffect(() => {
    const timeout = setTimeout(() => {
      setCurrentVideo((prevVideo) => (prevVideo + 1) % Videos.length);
    }, videoDuration || 90000);
    return () => clearTimeout(timeout);
  }, [currentVideo, videoDuration]);

  useEffect(() => {
    const handleResize = () => setIsMobile(window.innerWidth < 768);
    window.addEventListener("resize", handleResize);
    handleResize();
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  useEffect(() => {
    if (isSafari() && videoRef.current) {
      const player = videoRef.current;
      player.controls = false;
      player.playsInline = true;
      player.muted = true;
      player.setAttribute("muted", "");
      player.autoplay = true;

      setTimeout(() => {
        const promise = player.play();
        if (promise?.then) {
          promise.catch(() => {
            if (videoParentRef.current) {
              videoParentRef.current.style.display = "none";
            }
          });
        }
      }, 0);
    }
  }, [isMobile]);

  return (
    <>
      <div className="Home" ref={videoParentRef}>
        <div className="image-overlay"></div>

        {videoUrl && (
          <video
            ref={videoRef}
            src={videoUrl}
            loop
            muted
            autoPlay
            playsInline
            preload="metadata"
            className="video-background active"
            onEnded={() => setCurrentVideo((prev) => (prev + 1) % Videos.length)}
            onError={() => console.error("Video failed to load")}
          />
        )}

        <div className="HomeS1VCont">
          <div className="HomeS1V2">
            <span className="HomeS1V2P1 TFut24PxPC">{section1?.sub_title}</span>
            <span className="HomeS1V2P2 TGLo64PxPC">
              {section1?.title?.split("family").length > 1 ? (
                <>
                  {section1.title.split("family")[0]}
                  <br />
                  <span className="HomeS1V2P21">family{section1.title.split("family")[1]}</span>
                </>
              ) : (
                section1?.title
              )}
            </span>
            <span className="HomeS1V2P3 TFut24PxPC">{section1?.description}</span>
          </div>
          <div className="HomeS1V2P4">
            <Link
              to={section1?.button_link || "#"}
              className="HomeS1V2P4A TFut16PxPCUC"
              onMouseEnter={() => setImgSrc(HeroHomeIconHover)}
              onMouseLeave={() => setImgSrc(HeroHomeIconR)}
            >
              {section1?.button_text} <img src={imgSrc} alt="" className="HomeS1V2P4Img" />
            </Link>
          </div>
        </div>
      </div>
    </>
  );
}
